import styled from '@emotion/styled';

export const ContainerAside = styled.aside`
  background-color: #1E213A;
  padding: 25px 0 10px 0;
  min-width: 320px;
  color: #E7E7EB;
`;
